import { render, staticRenderFns } from "./HealthCase.vue?vue&type=template&id=0d5a5124&scoped=true&"
import script from "./HealthCase.vue?vue&type=script&lang=js&"
export * from "./HealthCase.vue?vue&type=script&lang=js&"
import style0 from "./HealthCase.vue?vue&type=style&index=0&id=0d5a5124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5a5124",
  null
  
)

export default component.exports